export default __webpack_public_path__ + "static/NBInternationalPro-Medium-36b8b8f777298220492287cd67af5c4c.woff2";